CarouselVue(data-test='carousel' :total='programs.length' @index-updated='index => setCurrentIndex(index.value)')
  .fp-slider--image(v-for='(program, index) in programs' :key='index' :class='{"-active": index === currentIndex}' :data-test='`carousel.image-${index}`')
    router-link.fp-link.-no-text-decoration(:to='program.route' :id='program.id')
      .fp-featured-content(data-test='image')
        img(:src='program.imageUrl' :alt='program.title')
        .fp-featured-content--background
        .fp-featured-content--description
          span.fp-text.-text-2xl.-text-semi-bold(data-test='name') {{ program.title }}
